import { Alert } from '@mantine/core'
import AlertClasses from './styles.module.css'

export default Alert.extend({
    defaultProps: {
        variant: 'outline',
        radius: 'lg',
    },
    classNames: AlertClasses,
})
